export default (appId: string, appKey: string) =>
  import(/* webpackChunkName: "algoliasearch" */ 'ha/helpers/algoliaWrapper.ts')
    .then(module => module.default)
    .then(algolia => algolia(appId, appKey));
